import React from 'react';

import { YotpoWidgetProps, useYotpoWidget } from '../Yotpo';

type ReviewCountProps = Pick<YotpoWidgetProps, 'product'>;

/**
 * @param props
 * @constructor
 */
export function ReviewCount(props: ReviewCountProps) {
    const { ProductStars } = useYotpoWidget();

    return <ProductStars {...props} />;
}
